export type PgmLevelCatalogEntry = {
  careerPath?: string | null;
  curriculumVersion?: string | null;
  level: number;
  levelCode: string;
  programName?: string | null;
};

export const INCOMPLETE_PGM_LEVEL_MESSAGE =
  "This person already has an incomplete level. Finish, close, or archive that level before adding another.";

export const INCOMPLETE_LIFELONG_LEARNING_LEVEL_MESSAGE =
  "This person already has an incomplete level. Finish, close, or delete that level before adding another.";

export function formatPgmLevelTitle(level: PgmLevelCatalogEntry): string {
  if (level.level === 0) {
    return "Qualifying Level";
  }

  if (level.careerPath) {
    return `Level ${level.level} ${level.careerPath}`;
  }

  return `Level ${level.level}`;
}

export function buildPgmLevelSelectOptions(levels: PgmLevelCatalogEntry[]) {
  return levels.map((level) => ({
    value: level.levelCode,
    label: `${formatPgmLevelTitle(level)} (${level.levelCode})`
  }));
}

export function personHasIncompletePgmLevel(programHistory: Array<{ completeCode?: string | null }>): boolean {
  return programHistory.some((level) => !level.completeCode?.trim());
}

export function formatLifelongLearningLevelTitle(level: PgmLevelCatalogEntry): string {
  const base = formatPgmLevelTitle(level);
  if (level.programName) {
    return `${base} ${level.programName}`;
  }

  return base;
}

export function buildLifelongLearningLevelSelectOptions(levels: PgmLevelCatalogEntry[]) {
  return levels.map((level) => ({
    value: level.levelCode,
    label: `${formatLifelongLearningLevelTitle(level)} (${level.levelCode})`
  }));
}

export function personHasIncompleteLifelongLearningLevel(
  certificationHistory: Array<{
    levelCode?: string | null;
    completeCode?: string | null;
    archived?: boolean;
  }>
): boolean {
  return certificationHistory.some((cert) => !!cert.levelCode?.trim() && !cert.archived && !cert.completeCode?.trim());
}
